<template>
  <div class="trade-list-component">
    <v-card class="section-card px-5 card-mobile" width="93vw" outlined>
      <v-col col="12">
        <v-btn
          v-if="tradesSelected.length > 0"
          class="mx-auto delete-trades col-3"
          @click="deleteSelected"
          >{{ $t("btnDeleteSelected") }}</v-btn
        >
      </v-col>
      <h3 v-if="trades.length === 0" class="text-center my-12">
        <v-icon class="d-flex align-center justify-center mt-12 mb-5" x-large
          >fa-regular fa-grin-beam-sweat</v-icon
        >
        {{ $t("noTrades") }}
      </h3>

      <v-data-table
        v-else
        style="background-color: rgba(0, 0, 0, 0)"
        :headers="headers"
        :items="trades"
        :page="1"
        :pageCount="this.$store.state.book.totalPages"
        :options.sync="options"
        :server-items-length="this.$store.state.book.totalElements"
        :loading="this.$store.state.book.loadingTrades"
        :items-per-page="15"
        :show-select="!shared"
        v-model="tradesSelected"
      >
        <!--template v-slot:item="{ item }" @click="showTrade"></template!-->
        <template v-slot:item.side="{ item }">
          <i :style="`color: ${getTradeSideColor(item.side)}; font-size: 15px;`"
            >{{ getTradeSideText(item.side) }}</i>
        </template>
        <template v-slot:item.mood="{ item }">
          <v-chip style="color: var(--v-mediumGray-base) !important;" class="mood-span" small outlined>
            <v-icon left small>{{ getMoodIcon(item.mood) }}</v-icon>
            {{ getMoodText(item.mood) }}
          </v-chip>
        </template>
        <template v-slot:item.netProfit="{ item }">
          <v-chip
            :class="getNetProfitColor(item.netProfit)"
            style="color: #ffffff"
            ><span class="netProfit-span">{{ item.netProfit }}</span></v-chip
          >
        </template>
        <template v-slot:item.broker="{ item }">
          <i class="rowData">{{ item.broker }}</i>
        </template>
        <template v-slot:item.strategy="{ item }">
          <i v-if="item.strategy != null" class="rowData">{{
            item.strategy.name
          }}</i>
          <i v-else class="rowData">{{ $t("none") }}</i>
        </template>
        <template v-slot:item.asset="{ item }">
          <i class="rowData">{{ item.asset }}</i>
        </template>
        <!--template v-slot:item.openTime="{ item }">
                    <i class="rowData">{{ `${item.openTime.toISOString().substr(0, 10).replace('-', '/').replace('-',
                        '/')} ${item.openTime.toISOString().substr(11, 8)}` }}</i>
                </template!-->
        <template v-slot:item.openTime="{ item }">
          <i class="rowData">{{
            `${String(item.openTime.getDate()).padStart(2, "0")}/${String(
              item.openTime.getMonth() + 1
            ).padStart(2, "0")}/${item.openTime.getFullYear()} ${String(
              item.openTime.getHours()
            ).padStart(2, "0")}:${String(item.openTime.getMinutes()).padStart(
              2,
              "0"
            )}:${String(item.openTime.getSeconds()).padStart(2, "0")}`
          }}</i>
          <!--i class="rowData">{{ `${item.openTime.toLocaleString().substr(0, 10).replace('-', '/').replace('-', '/').replace(',', '')} ${item.openTime.toLocaleString().substr(10, 9).replace(',', '')}` }}</i!-->
        </template>
        <template v-slot:item.tradeTime="{ item }">
          <i class="rowData">{{ getTradeTime(item.tradeTime) }}</i>
        </template>
        <template v-slot:item.entryPrice="{ item }">
          <i class="rowData">{{ item.entryPrice }}</i>
        </template>
        <template v-slot:item.closePrice="{ item }">
          <i class="rowData">{{ item.closePrice }}</i>
        </template>
        <template v-slot:item.stopLossPrice="{ item }">
          <i class="rowData">{{ item.stopLossPrice }}</i>
        </template>
        <template v-if="!isMobile" v-slot:item.action="{ item }">
          <div class="flex">
            <v-icon small class="icon mr-3" @click="showTrade(item)"
              >fa-regular fa-eye</v-icon
            >
            <v-icon
              v-if="!shared"
              small
              class="icon mr-3"
              @click="editTrade(item)"
              >fa-regular fa-pen</v-icon
            >
            <v-icon
              v-if="!shared && !item.brokerAccount.verified"
              small
              class="icon"
              @click="deleteTrade(item)"
              >fa-regular fa-trash</v-icon
            >
          </div>
        </template>
      </v-data-table>
    </v-card>

    <v-overlay :dark="false" :value="deleteMultipleTradesWindow">
      <DeleteMultipleTrades
        @closeWindow="closeDeleteMultipleWindow"
        :trades="tradesToDelete"
      />
    </v-overlay>
    <v-overlay :dark="false" :value="deleteTradeWindow">
      <DeleteTrade @closeDeleteWindow="closeDeleteWindow" :trade="tradeToSee" />
    </v-overlay>
    <v-overlay :dark="false" :value="showTradeWindow">
      <FullTrade @closeShowWindow="closeShowWindow" :trade="tradeToSee" />
    </v-overlay>
    <v-overlay :dark="false" :value="editTradeWindow">
      <EditTrade @closeEditWindow="closeEditWindow" :trade="tradeToSee" />
    </v-overlay>
  </div>
</template>

<script>
import Moods from "./moods";
import { mapMutations } from "vuex";
import DeleteTrade from "./components/DeleteTrade";
import FullTrade from "./components/FullTrade";
import EditTrade from "./components/EditTrade";
import DeleteMultipleTrades from "./components/DeleteMultipleTrades";

export default {
  name: "TradeList",
  components: { DeleteMultipleTrades, EditTrade, FullTrade, DeleteTrade },
  props: {
    shared: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      trades: this.$store.state.book.trades,
      options: {},
      // Actions variables
      editedIndex: -1,
      editedItem: {
        openTime: "",
        tradeTime: "",
        side: "",
        assetId: 0,
        strategyId: 0,
        brokerAccountId: 0,
        entryPrice: 0,
        closePrice: 0,
        stopLossPrice: 0,
        netProfit: 0,
        commisions: 0,
      },
      defaultItem: {
        openTime: "",
        tradeTime: "",
        side: "",
        assetId: 0,
        strategyId: 0,
        brokerAccountId: 0,
        entryPrice: 0,
        closePrice: 0,
        stopLossPrice: 0,
        netProfit: 0,
        commisions: 0,
      },
      deleteMultipleTradesWindow: false,
      deleteTradeWindow: false,
      showTradeWindow: false,
      editTradeWindow: false,
      tradeToSee: null,
      tradesToDelete: [],
      tradesSelected: [],
    };
  },
  watch: {
    options: {
      handler() {
        this.changeTradesPageable();
      },
      deep: true,
    },
    "$store.state.book.trades": function () {
      this.trades = this.$store.state.book.trades;
    },
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
    headers() {
      let headers = [
        {
          text: this.$t("headers_TradeList.asset"),
          align: "left",
          value: "asset.assetName",
        },
        { text: this.$t("headers_TradeList.side"), value: "side" },
        { text: this.$t("headers_TradeList.openTime"), value: "openTime" },
        { text: this.$t("headers_TradeList.tradeTime"), value: "tradeTime" },
        {
          text: this.$t("headers_TradeList.entryPrice"),
          sortable: false,
          value: "entryPrice",
        },
        { text: this.$t("headers_TradeList.mood"), value: "mood" },
        { text: this.$t("headers_TradeList.strategy"), value: "strategy" },
        { text: this.$t("headers_TradeList.netProfit"), value: "netProfit" },
      ];
      if (!this.isMobile) {
        headers.push({
          text: this.$t("headers_TradeList.actions"),
          value: "action",
          sortable: false,
        });
      }
      return headers;
    },
  },
  methods: {
    getTradeSideColor(side) {
      return side.toUpperCase() === "BUY" ? "#008CFF" : "#FF7300";
    },
    getNetProfitColor(netProfit) {
      return netProfit > 0 ? "darkgreen" : "darkred";
    },
    getMoodColor(mood) {
      switch (mood) {
        case "Relaxed":
          return "#4d6556";
        case "Cautious":
          return "#386538";
        case "Concentrated":
          return "#376563";
        case "Confident":
          return "#376563";
        case "Excited":
          return "#28655c";
        case "Anxious":
          return "#28655c";
        case "Happy":
          return "#0f6500";
        case "Optimistic":
          return "#1d5465";
        case "Aggressive":
          return "#651540";
        case "Angry":
          return "#650700";
        case "Bored":
          return "#65412e";
        case "Mad":
          return "#651540";
        case "Nervous":
          return "#651540";
        case "Sad":
          return "#65412e";
        case "Upset":
          return "#651540";
        case "None":
          return "#555555";
        default:
          return "#651540";
      }
    },
    getMoodIcon(mood) {
      switch (mood) {
        case "Relaxed":
          return "fa-laugh-wink";
        case "Cautious":
          return "fa-smile";
        case "Concentrated":
          return "fa-meh-blank";
        case "Confident":
          return "fa-smile-beam";
        case "Excited":
          return "fa-grin-tongue";
        case "Happy":
          return "fa-grin-beam";
        case "Optimistic":
          return "fa-grin-stars";
        case "Aggressive":
          return "fa-meh-rolling-eyes";
        case "Angry":
          return "fa-angry";
        case "Bored":
          return "fa-frown";
        case "Mad":
          return "fa-angry";
        case "Nervous":
          return "fa-grimace";
        case "Sad":
          return "fa-sad-tear";
        case "Upset":
          return "fa-frown-open";
        case "None":
          return "fa-ban";
        default:
          return "fa-flushed";
      }
    },
    getTradeSideText(side) {
      return side.toUpperCase() === "BUY" ? this.$t('Buy') : this.$t('Sell');
    },
    getMoodText(mood) {
      let currentMood = Moods.find((cmood) => cmood.en === mood);
      if (this.$i18n.locale === "en") {
        return currentMood.en;
      } else {
        return currentMood.es;
      }
    },
    getTradeTime(duration) {
      let message = duration.days > 0 ? `${duration.days}d` : "";
      message = `${message} ${duration.hours > 0 ? `${duration.hours}h` : ""}`;
      message = `${message} ${
        duration.minutes > 0 ? `${duration.minutes}m` : ""
      }`;
      message = `${message} ${
        duration.seconds > 0 ? `${duration.seconds}s` : ""
      }`;
      return message;
    },
    ...mapMutations(["setTradesPageable"]),
    changeTradesPageable() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      let pageable = {
        size:
          itemsPerPage === -1
            ? this.$store.state.book.totalElements
            : itemsPerPage,
        page: itemsPerPage === -1 ? 0 : page - 1,
        sort: "openTime,desc",
      };
      if (sortBy[0] !== undefined) {
        pageable.sort = sortBy[0] + "," + (sortDesc[0] ? "desc" : "asc");
      }
      this.setTradesPageable(pageable);
    },
    showTrade(trade) {
      this.tradeToSee = trade;
      this.showTradeWindow = true;
    },
    editTrade(trade) {
      this.tradeToSee = trade;
      this.editTradeWindow = true;
    },
    deleteTrade(trade) {
      this.tradeToSee = trade;
      this.deleteTradeWindow = true;
    },
    closeShowWindow() {
      this.showTradeWindow = false;
    },
    closeEditWindow() {
      this.editTradeWindow = false;
    },
    closeDeleteWindow() {
      this.deleteTradeWindow = false;
    },
    closeDeleteMultipleWindow() {
      this.deleteMultipleTradesWindow = false;
    },
    deleteSelected() {
      this.tradesToDelete = [];
      this.tradesSelected.forEach((trade) => {
        if (!trade.brokerAccount.verified) this.tradesToDelete.push(trade.id);
      });

      if (this.tradesToDelete.length > 0) {
        this.deleteMultipleTradesWindow = true;
        this.tradesSelected = [];
      } else
        alert("Hey! You can not delete trades traded on a audited account.");
    },
  },
};
</script>



<style lang="scss" scoped>
@media (max-width: 599px) {
  .card-mobile {
    margin-left: 0px;
  }
}

.trade-list-component{
  .v-data-table{
    i{
      font-style: normal;
    }
  }
}
.rowData {
  font-size: 15px;
  color: var(--v-dark-base);
}

.delete-trades {
  background-color: var(--v-calmRed-base) !important;
  &:hover {
    background-color: var(--v-calmRed-base) !important;
  }
}
.old-filters {
  display: none;
}

.green {
  background-color: var(--v-darkGreen-base) !important;
  color: var(--v-white-base) !important;
}

.darkgreen {
  background-color: var(--v-darkGreen-base) !important;
  color: var(--v-white-base) !important;
}
.red {
  background-color: var(--v-darkRed-base) !important;
  color: var(--v-white-base) !important;
}

.darkred {
  background-color: var(--v-darkRed-base) !important;
  color: var(--v-white-base) !important;
}
@media (max-width: 600px) {
  .mobile-flex {
    flex-direction: row;
    width: 100px;
  }
}
</style>
